import { configure } from "mobx";

import { getInitialLocale, setLocale } from "../i18n.react";
import { initGlobalErrorHandling } from "./errors";
import { initSentry } from "./sentry";

/**
 * Page-wide setup, before the app renders: library configuration, listeners
 * on `window`, and the active locale. Run it once per page — running it again
 * would stack up the error listeners.
 */
export async function setUpPage({ sentry }: { sentry: boolean }) {
  configure({ enforceActions: "never" });

  if (sentry) initSentry();
  initGlobalErrorHandling();

  await setLocale(getInitialLocale());
}
